import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Tabs = ({ tabs, activeTab, onChange, className = '' }) => {
  const [activeIndex, setActiveIndex] = useState(activeTab || 0);

  // Sync activeIndex if activeTab prop changes
  useEffect(() => {
    if (typeof activeTab === 'number') {
      setActiveIndex(activeTab);
    }
  }, [activeTab]);

  const handleTabClick = (index) => {
    if (tabs[index].disabled) return; // Prevent clicking disabled tab
    setActiveIndex(index);
    if (onChange) {
      onChange(index);
    }
  };

  return (
    <div className={`flex flex-wrap gap-4 ${className}`}>
      {tabs.map((tab, index) => (
        <button
          key={index}
          onClick={() => handleTabClick(index)}
          disabled={tab.disabled}
          className={`px-4 py-2 rounded-full text-base font-semibold transition-colors
            ${activeIndex === index ? 'bg-[#f3f8ff] text-[#002d72]' : 'text-[#667085] hover:text-[#475467]'}
            ${tab.disabled ? 'cursor-not-allowed opacity-50 hover:text-[#667085]' : 'cursor-pointer'}
          `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      content: PropTypes.node,
    })
  ).isRequired,
  activeTab: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Tabs;
